import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../Theme';

const Tabs = styled.nav`
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: ${theme.colors.background};
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

const Tab = styled(Link)`
  padding: 10px 20px;
  text-decoration: none;
  color: ${theme.colors.secondary};
  background-color: ${theme.colors.darkGreen};
  border-radius: 5px;
  font-weight: bold;

  &.active {
    background-color: ${theme.colors.primary};
    color: ${theme.colors.secondary};
  }
`;

const Navigation = ({ isCreator }) => (
  <Tabs>
    <Tab to="/feed" className={({ isActive }) => (isActive ? 'active' : '')}>MUSIC</Tab>
    <Tab to="/library" className={({ isActive }) => (isActive ? 'active' : '')}>About</Tab>
    <Tab to="/" className={({ isActive }) => (isActive ? 'active' : '')}>Home</Tab>
    {isCreator && <Tab to="/creator" className={({ isActive }) => (isActive ? 'active' : '')}>Creator</Tab>}
  </Tabs>
);

export default Navigation;
